/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Radio = require('backbone.radio');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var PrinterView = require('common/views/PrinterView');

var GetApplicationDetails = require('../../common/services/GetApplicationDetails');

module.exports = function(applicationId) {
  NProgress.start();
  NProgress.set(0.3);
  GetApplicationDetails(applicationId)
    .done(function(applicationDetails) {
      NProgress.set(0.6);
      var formIdentifier = applicationDetails.formIdentifier;
      var applicationTypeId = applicationDetails.applicationTypeId;
      var entityId = applicationDetails.entityId;

      var BuildApplicationPromise = Radio.channel('nd:application').request('build:' + formIdentifier, {
        applicationId: applicationId,
        applicationTypeId: applicationTypeId,
        entityId: entityId,
        mode: 'print',
        isReadOnly: true
      });

      BuildApplicationPromise.done(function(applicationFormView) {
        Radio.channel('header').trigger('hide:header');
        Radio.channel('footer').trigger('hide:footer');
        NavUtils.navigate('nondep/application/' + applicationId + '/print');
        applicationFormView.model.set({
          applicationId: applicationId,
          applicationDetails: applicationDetails
        });
        Scaffold.content.show(
          new PrinterView({
            viewToPrint: applicationFormView
          })
        );
        NProgress.done();
      }).fail(function(err) {
        NProgress.done();
      });
    })
    .fail(function(err) {
      NProgress.done();
    });
};
